import { render, staticRenderFns } from "./AsociarTelegram.vue?vue&type=template&id=50219990&"
import script from "./AsociarTelegram.vue?vue&type=script&lang=js&"
export * from "./AsociarTelegram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports